import { z } from 'zod/v4';
import { INormalText, NORMAL_TEXT_SCHEMA } from './text/text.interfaces';
import { Brand } from '../branded-types';

export type LinkId = Brand<string, 'linkId'>;

export const LINK_SCHEMA: z.ZodType<ILink> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as LinkId)
    .optional(),
  texts: z.array(NORMAL_TEXT_SCHEMA),
  positionOrder: z.number(),
});

export interface ILink {
  id?: LinkId;
  texts: INormalText[];
  positionOrder: number;
}

export const DEFAULT_LINK: ILink = {
  texts: [],
  positionOrder: 0,
};
